import React, { useEffect, useState } from 'react'
import List from '../../components/SiteManagement/Index/list'
import Layout from '../../components/common/pageLayout'
import { v2_site_management_stats } from '../../actions/v2/siteManagement'
const Index = () => {
  const [stats, setStats] = useState(null)
  useEffect(() => {
    v2_site_management_stats().then((res) => {
      if (res.status) {
        setStats(res.result.counts)
      }
    })
  }, [])
  return (
    <>
      <Layout
        title={'Site Management'}

      >
        {/* <SearchFilter /> */}
        <List
          stats={stats}
        />
      </Layout>

    </>
  )
}

export default Index